

















import { Component, Watch } from 'vue-property-decorator';
import MinCard from './min-card.vue';
import FullFilter from './full-filter.vue';
import FullRuleList from './full-rule-list.vue';
import SuperviseServices from '@/services/supervise';
import DictMixin from '@/mixins/dict-mixin';
import { mixins } from 'vue-class-component';
import { FilterItem } from '@/interfaces/filter-items';
import PageMixin from '@/mixins/page-mixin';
import { sleep } from '@/libs/util';
@Component({
  components: { FullFilter, FullRuleList, MinCard }
})
export default class FullAlert extends mixins(DictMixin, PageMixin) {
  superSrv = new SuperviseServices();
  activeKey: number = 1;
  listType = 'alert';

  created() {
    this.init();
  }

  interval: any;
  async getAllData() {
    this.getList();
    await sleep(1500);
    this.getTotal();
    clearInterval(this.interval);
    this.interval = setInterval(() => {
      this.getTotal();
      this.getList({}, false);
    }, 15000);
  }

  mounted() {
    this.getAllData();
  }

  beforeDestroy() {
    clearInterval(this.interval);
  }

  list: any[] = [];
  async getList(params?: object, loading: boolean = true) {
    let query = this.$route.query;
    this.loading = loading;
    let res = await this.superSrv.getList({ ...this.filter, ...query, ...params, page: this.page, limit: this.limit });
    this.list = res.list.map((v: any) => {
      return {
        ...v,
        ...v.sourceAsMap
      };
    });
    this.total = res.totalCount;
    this.loading = false;
  }

  getCurrentList(type: number) {
    this.page = 1;
    if (type === 0) this.filter = { alertHandleStatus: 1, alertReviewStatus: 1 };
    if (type === 1) this.filter = { alertReviewStatus: 1 };
    if (type === 2) this.filter = { alertHandleStatus: 3, alertReviewStatus: 3 };
    if (type === 3) this.filter = { alertReviewStatus: 3 };
    this.getList();
  }

  showCard = [
    { title: '经办复核均逾期', number: 0, type: 0, tip: '经办状态和复核状态均为超时完结状态的预警记录', unit: '决策' },
    { title: '复核逾期', number: 0, type: 1, tip: '复核状态为超时完结状态的预警记录', unit: '决策' },
    { title: '经办复核均忽略', number: 0, type: 2, tip: '经办状态和复核状态均为已忽略状态的预警记录', unit: '决策' },
    { title: '复核忽略', number: 0, type: 3, tip: '复核状态为已忽略状态的预警记录', unit: '决策' }
  ];
  async getTotal() {
    let res = await this.superSrv.getTotal();
    this.showCard[0].number = res.count1;
    this.showCard[1].number = res.count2;
    this.showCard[2].number = res.count3;
    this.showCard[3].number = res.count4;
  }

  filter: any = {};
  excuteFilter(res: object) {
    this.page = 1;
    this.filter = res;
    this.getList();
  }

  resetFilter() {
    this.page = 1;
    this.filter = {};
    this.getList();
  }

  @Watch('$route')
  onRouteChange() {
    this.$route.path === '/task/full' && this.getList();
  }

  filterItems: FilterItem[] = [];

  init() {
    if (!this.DICT_ALERT_LEVEL) {
      setTimeout(() => {
        this.init();
      }, 100);
    } else {
      this.filterItems = [
        { label: '预警消息', key: 'alertMessage', type: 'input' },
        { label: '预警等级', key: 'alertLevel', type: 'select', options: this.DICT_ALERT_LEVEL },
        { label: '预警日期', key: 'alertDate', type: 'datePicker' },
        { label: '决策集', key: 'ruleSetName', type: 'input' },
        { label: '决策模型', key: 'ruleName', type: 'input' },
        { label: '负责人', key: 'ruleOwnerName', type: 'input' },
        { label: '管理板块', key: 'ruleOwnerPlate', type: 'select', options: this.DICT_BUSINESS_UNIT },
        { label: '管理部门', key: 'ruleOwnerDept', type: 'select', options: this.DICT_BUSINESS_DEPT },
        { label: '决策大类', key: 'ruleFirstLevel', type: 'select', options: this.DICT_JOURNEY_SCENE },
        { label: '决策中类', key: 'ruleSecondLevel', type: 'select', options: this.DICT_JOURNEY_SUB_SCENE },
        { label: '决策小类', key: 'ruleThirdLevel', type: 'select', options: this.DICT_JOURNEY_SCENE_STEP },
        { label: '电子邮件', key: 'alertEmailStatus', type: 'select', options: this.DICT_EMAIL_SEND_STATUS },
        { label: '企业微信', key: 'alertEwechatStatus', type: 'select', options: this.DICT_EWECHAT_SEND_STATUS }
      ];
    }
  }
}
